var _dec, _class, _Text;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { Component } from 'react';
import { passthroughProps, getElementType } from '@instructure/ui-react-utils';
import { withStyle } from '@instructure/emotion';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { allowedProps, propTypes } from './props';

/**
---
category: components
---
**/
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
let Text = (_dec = withStyle(generateStyle, generateComponentTheme), _dec(_class = (_Text = class Text extends Component {
  checkProps() {
    const _this$props = this.props,
      variant = _this$props.variant,
      lineHeight = _this$props.lineHeight,
      weight = _this$props.weight,
      fontStyle = _this$props.fontStyle;
    if (variant) {
      if (lineHeight) {}
      if (weight) {}
      if (fontStyle) {}
    }
  }
  componentDidMount() {
    var _this$props$makeStyle, _this$props2;
    (_this$props$makeStyle = (_this$props2 = this.props).makeStyles) === null || _this$props$makeStyle === void 0 ? void 0 : _this$props$makeStyle.call(_this$props2);
    this.checkProps();
  }
  componentDidUpdate() {
    var _this$props$makeStyle2, _this$props3;
    (_this$props$makeStyle2 = (_this$props3 = this.props).makeStyles) === null || _this$props$makeStyle2 === void 0 ? void 0 : _this$props$makeStyle2.call(_this$props3);
    this.checkProps();
  }
  render() {
    var _this$props$styles;
    const children = this.props.children;
    const ElementType = getElementType(Text, this.props);
    return _jsx(ElementType, {
      ...passthroughProps(this.props),
      css: (_this$props$styles = this.props.styles) === null || _this$props$styles === void 0 ? void 0 : _this$props$styles.text,
      ref: this.props.elementRef,
      children: children
    });
  }
}, _Text.displayName = "Text", _Text.componentId = 'Text', _Text.allowedProps = allowedProps, _Text.propTypes = propTypes, _Text.defaultProps = {
  as: 'span',
  wrap: 'normal',
  size: 'medium',
  letterSpacing: 'normal',
  children: null
}, _Text)) || _class);
export default Text;
export { Text };